// extracted by mini-css-extract-plugin
export default {"container":"CompanyAffiliation_container__NZIFD","other":"CompanyAffiliation_other__9vw-k"};